import DomComponent from '../lib/domComponent';
import { each, mq } from '../lib/util';

export default class ValidationComponent extends DomComponent {
    static selector = '[data-js-validate]';

    requiredInputSelector = '[data-required]'
    errorMessageMap = {};

    constructor(el) {
        super(el);

        this.el.addEventListener('submit', (e) => {
            e.preventDefault();

            this.validate().then((valid) => {
                if (valid) {
                    e.target.submit();
                };
            });

        })
    }

    validate() {

        return new Promise((resolve) => {
            let valid = true;
            const promises = [];

            each(this.el.querySelectorAll(this.requiredInputSelector), (input) => {
                if (!input.value) {
                    promises.push(new Promise((resolve) => resolve(false)));
                    this.createErrorMessage(input);
                } else {
                    this.removeErrorMessage(input);

                    if (input.type === 'email') {   
                        const encodedEmail = encodeURIComponent(input.value);
                        const url = "/umbraco/rhythm/briteverifyapi/verify?email=" + encodedEmail;
   
                        const promise = fetch(url)
                        .then((response) => response.json())
                        .then((result) => {
                            if (result) {
                                this.removeErrorMessage(input);
                            }
                            else {
                                this.createErrorMessage(input, 'Please enter a valid email');
                            }

                            return result;
                        });
                    
                        promises.push(promise);
                    }
                    else {
                        promises.push(new Promise((resolve) => resolve(true)));
                    }
                }
            });

            if (promises.length > 0) {
                Promise.all(promises).then((results) => {
                    resolve(results.indexOf(false) === -1);
                });
            }
            else {
                resolve(valid);
            }        
        });
    }

    createErrorMessage(input, message) {
        if(!input.classList.contains('validation-error')) {
            const name = input.dataset.required ? input.dataset.required : input.getAttribute('name');
            input.classList.add('validation-error')

            let div = document.createElement('div');
            div.classList.add('validation-error-message');
            div.innerText = message || `Please enter a valid ${name}`;

            input.parentElement.appendChild(div);

            this.errorMessageMap[name] = div;
        }
    }

    removeErrorMessage(input) {
        if(input.classList.contains('validation-error')) {
            const name = input.dataset.required ? input.dataset.required : input.getAttribute('name');
            input.classList.remove('validation-error');

            this.errorMessageMap[name].remove();
            delete this.errorMessageMap[name];
        }
    }
}
